import Vue from 'vue'

Vue.filter('thousandSeparated', (value: string) => {
  if (!value) { return '0' }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})
